import { render, staticRenderFns } from "./triggerRecord.vue?vue&type=template&id=f6946d6e&scoped=true&"
import script from "./triggerRecord.vue?vue&type=script&lang=js&"
export * from "./triggerRecord.vue?vue&type=script&lang=js&"
import style0 from "./triggerRecord.vue?vue&type=style&index=0&id=f6946d6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6946d6e",
  null
  
)

export default component.exports